import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-farewell-ceremony',
  templateUrl: './farewell-ceremony.component.html',
  styleUrls: ['./farewell-ceremony.component.scss']
})
export class FarewellCeremonyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
